// API URL configuration
// Always use relative URLs - this ensures the frontend calls the API on the same domain
// whether in development preview or production deployment

export const API_URL = '';
